import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const MonthCalendarDaysOfWeek = ({ calendarObj: { atualDate, activeScreen } }) => {
  const { t } = useTranslation();

  const { selectedStart } = useSelector((state) => state.calendarReducer);
  let startDate = moment(selectedStart).startOf("week");
  const days = [];

  if (activeScreen !== "day") {
    for (let i = 0; i < 7; i++) {
      const sameDate = startDate.clone().add(i, "day").format("DD/MM/YYYY") === atualDate.format("DD/MM/YYYY");
      days.push(
        <div className="dayWeek" key={"kDay" + startDate.clone().add(i, "day").format("ddd")}>
          <p className="dayWeekName ">{t(startDate.clone().add(i, "day").format("ddd").toUpperCase())}</p>
          {activeScreen === "week" && (
            <p className={`dayWeekNumber ${sameDate ? "selected" : ""}`}>
              {startDate.clone().add(i, "day").format("DD")}
            </p>
          )}
        </div>,
      );
    }
  } else {
    days.push(
      <div className="dayWeek" key={"kDay" + moment(selectedStart).clone().format("ddd")}>
        <p className="dayWeekName">{t(moment(selectedStart).clone().format("ddd").toUpperCase())}</p>
      </div>,
    );
  }

  return (
    <div key={"kDays" + startDate.clone().format("ddd")} className="daysWeek">
      {days}
    </div>
  );
};

export default MonthCalendarDaysOfWeek;
